import { BdContentCondition } from './condition';

export const BD_YEARS_CONTENT_CONDITION_ID = 'year';

export class BdYearsCondition extends BdContentCondition<number> {
  constructor(includes: number[], excludes: number[]) {
    super(BD_YEARS_CONTENT_CONDITION_ID, includes, excludes);
  }
}
